import * as ConstantRouter from '@/constant/router'

const route = {
  path: '/admin/login',
  name: ConstantRouter.DASHBOARD_LOGIN,
  component: () => import(/* webpackChunkName: "dashboard-login" */ '@/dashboard/login')
}

export default route
